import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { ContentBlock, FullLineSeparator } from '../../styled';

import { StyledRewardsManagement } from './styled';

export const ScanRewardsManagement = () => {
  const enableTHRewardsTierToggleUI = useFlag(LaunchDarklyFlag.ENABLE_TH_REWARD_TIER_TOGGLE_UI);
  if (!enableTHRewardsTierToggleUI) {
    return null;
  }

  return (
    <ContentBlock>
      <FullLineSeparator margin={`0 -${primitive.$spacing5}`} />
      <StyledRewardsManagement data-testid="rewards-management" />
    </ContentBlock>
  );
};

export default ScanRewardsManagement;
